import { SigninComponent } from './signin.component';
import { Injectable } from '@angular/core';
import { MatDialogRef, MatDialogConfig, MatDialog } from '@angular/material/dialog';

@Injectable()
export class SigninService {

  dialogRef: MatDialogRef<SigninComponent>;

  constructor(private dialog: MatDialog) { }

  openDialog(queryParams?) {
    // let dialogRef: MatDialogRef<SigninComponent>;
    const config = new MatDialogConfig();
    this.dialogRef = this.dialog.open(SigninComponent, { panelClass: 'dialog', maxWidth: '400px' });
    this.dialogRef.componentInstance.queryParams = queryParams;
    return this.dialogRef.afterClosed();
  }

  closeDialog() {
    if (this.dialogRef) {
      this.dialogRef.close();
    }
  }

}
